import React from 'react';

// Styles
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './SponsorItem.style';

// Components
import ResponsivePicture from '@braindate/ui/lib/component/ResponsivePicture';

type Props = {
  sponsor: {
    url: string,
    name: string,
    logo?: string,
    logoAltText?: string,
  },
};

const useStyles = createUseThemeStyles(styles);

const SponsorItem = ({ sponsor }: Props) => {
  const { url, name, logo, logoAltText } = sponsor;

  const classes = useStyles();

  return (
    <a href={url} className={classes.root} target="_blank" rel="noreferrer">
      {logo && (
        <ResponsivePicture
          layoutClass={classes.logo}
          picture={logo}
          alt={logoAltText}
          provideFallback={true}
        />
      )}

      <h3 className={classes.name}>{name}</h3>
    </a>
  );
};

export default React.memo(SponsorItem);
